import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

const BASE_URL = import.meta.env.VITE_APP_INTEGRATION_BASE_URL;
const BILLING_BASE_URL = import.meta.env.VITE_APP_BILLING_BASE_URL;

export const connectXero = async () => {
  try {
    const url = `${BASE_URL}/v1/xero/connect?redirect_uri=${window.location.origin}/app/control-center/integrations/xero/callback`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    // if (response.status === 301 || response.status === 302) {
    //   const redirectUrl = response.headers.location;
    // }
    if (resData && resData.statusCode === 200) {
      //   window.location.href = resData;
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error: any) {
    if (error?.response?.status === 301 || error?.response?.status === 302) {
      const redirectUrl = error?.response?.headers?.location;
      console.log(redirectUrl);
    }
    throw error;
  }
};

export const callbackToXero = async ({
  state,
  code,
  scope,
  session_state,
}: {
  state: string;
  code: string;
  scope: string;
  session_state: string;
}) => {
  try {
    const url = `${BASE_URL}/v1/xero/callback`;
    const response = await axiosClient.get(`${url}`, {
      params: {
        state,
        code,
        scope,
        session_state,
        // originalUrl,
      },
    });
    const resData = response.data;
    if (response.status === 301 || response.status === 302) {
      const redirectUrl = response.headers.location;
      console.log(redirectUrl);
    }
    if (resData && resData.statusCode === 200) {
      //   window.location.href = resData;
      return resData.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    if (error?.response?.status === 301 || error?.response?.status === 302) {
      const redirectUrl = error?.response?.headers?.location;
      console.log(redirectUrl);
    }
    apiErrorHandler(error);
  }
};

export const getXeroItems = async (dropdown?: string) => {
  try {
    const url = `${BASE_URL}/xero/list-items`;
    const response = await axiosClient.get(`${url}`, {
      params: {
        dropdown,
      },
    });
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
export const getXeroTax = async () => {
  try {
    const url = `${BASE_URL}/xero/list-tax-rates`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const sendToXero = async ({
  invoiceId,
  currency,
  xeroRealmId,
}: {
  invoiceId: string;
  currency: string;
  xeroRealmId: string;
}) => {
  try {
    const url = `${BILLING_BASE_URL}/v1/invoice/send-to-xero`;
    const data = {
      dd_invoice_id: invoiceId,
      currency,
      realm_id: xeroRealmId,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const bulkSendToXero = async ({
  invoiceIds,
  currency,
  xeroRealmId,
}: {
  invoiceIds: string[];
  currency: string;
  xeroRealmId: string;
}) => {
  try {
    const url = `${BILLING_BASE_URL}/v1/billing/bulk/send-to-xero`;
    const data = {
      invoice_ids: invoiceIds,
      currency,
      realm_id: xeroRealmId,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

// yet to update
export const getXeroTenantId = async () => {
  try {
    const url = `${BASE_URL}/xero/tenant-id`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getXeroCustomers = async ({
  page = 1,
  perPage = 100,
}: {
  page?: number;
  perPage?: number;
}) => {
  try {
    const url = `${BASE_URL}/xero/list-customers?page=${page}&per_page=${perPage}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return {
        data: resData?.data?.contacts || [],
      };
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const disconnectXero = async () => {
  try {
    const url = `${BASE_URL}/v1/xero/disconnect`;
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getXeroServiceCategoryMappings = async () => {
  try {
    const url = `${BASE_URL}/v1/xero/service-category-mapping`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const mapXeroServiceCategories = async (data: any) => {
  try {
    const url = `${BASE_URL}/v1/xero/service-category-mapping`;
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getXeroRealmId = async () => {
  try {
    const url = `${BASE_URL}/xero/realm-id`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
